import React, { useState, useEffect } from "react";
import { Button } from "../../../../../_helpers/components/Button";
import { InputForm } from "../../../../../_helpers/components/Forms/InputLabel";
import { addTeam, editTeam, getTeam } from "../../../../../_api/Team";
import { useNavigate, useParams } from "react-router-dom";
import toast from "react-hot-toast";
import { BackButton } from "../../../../../_helpers/components/BackButton";

export const AddTeam = () => {
    const navigate = useNavigate();

    const { establishment_id, team_id } = useParams();
    const [name, setName] = useState("");
    const [remarks, setRemarks] = useState("");
    const [isLoading, setIsLoading] = useState(true);
    const [isSaving, setIsSaving] = useState(false);

    useEffect(() => {
        setIsLoading(true);
        if (team_id) {
            getTeam(team_id).then((resp) => {
                setName(resp.data.name);
                setRemarks(resp.data.remarks);
            });
        }
        setIsLoading(false);
    }, [team_id]);

    const _create = () => {
        const payload = {
            name: name,
            remarks: remarks,
        };
        setIsSaving(true);
        const request = team_id
            ? editTeam(establishment_id, payload)
            : addTeam(establishment_id, payload);
        request
            .then(() => {
                toast(team_id ? "L'équipe a été modifiée." : "L'équipe a été ajoutée.");
                navigate("/company/establishments/" + establishment_id);
            })
            .finally(() => setIsSaving(false));
    };

    return (
        <div className="min-h-full bg-gray-50">
            {/* Header */}
            <div className="bg-white border-b border-gray-200 shadow-sm">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
                    <div className="flex items-center justify-between flex-wrap gap-4">
                        <div className="flex items-center space-x-4">
                            <BackButton
                                title="Retour"
                            />
                            <div>
                                <h1 className="text-3xl font-bold text-gray-900">
                                    {team_id ? "Modifier" : "Ajouter"} un service / une équipe
                                </h1>
                                <p className="mt-2 text-sm text-gray-600">
                                    {/* {category_id ? "Modifiez" : "Créez"} une catégorie socio-professionnelle */}
                                </p>
                            </div>
                        </div>
                        <div className="flex flex-wrap gap-2">
                            <Button
                                action={() => _create()}
                                name={team_id ? "Modifier" : "Ajouter"}
                                loading={isSaving}
                            />
                        </div>
                    </div>
                </div>
            </div>

            {/* Contenu principal */}
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
                {isLoading ? (
                    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
                        <div className="flex items-center justify-center py-12">
                            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-app-primary"></div>
                        </div>
                    </div>
                ) : (
                    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
                        <InputForm
                            name="Nom"
                            value={name}
                            placeholder="Nom"
                            type="text"
                            set={setName}
                            required={true}
                        />
                        <InputForm
                            name="Notes"
                            value={remarks}
                            placeholder="Commentaires"
                            type="textarea"
                            set={setRemarks}
                            required={false}
                        />
                    </div>
                )}
            </div>
        </div>

    );
};
